"use client";

import type { HTMLAttributes, ReactNode } from "react";
import { useEffect, useRef, useState } from "react";
import { cn } from "../../helpers/styles";

const useStuck = (
	element?: HTMLElement | null,
	{ top, bottom }: { top?: number; bottom?: number } = {
		top: undefined,
		bottom: undefined,
	},
) => {
	const [isStuck, setStuck] = useState<boolean>();

	useEffect(() => {
		if (!element) {
			setStuck(false);
			return;
		}

		const checkPosition = () => {
			const rect = element.getBoundingClientRect();
			const isAtTop = typeof top === "number" && rect.top <= top;
			const isAtBottom = typeof bottom === "number" && rect.bottom - window.innerHeight >= bottom;

			setStuck(isAtTop || isAtBottom);
		};

		window.addEventListener("scroll", checkPosition);
		checkPosition();

		return () => {
			window.removeEventListener("scroll", checkPosition);
		};
	}, [element, top, bottom]);

	return isStuck;
};

type Props = {
	stuckClassName?: string;
	top?: number;
	bottom?: number;
	children: ReactNode;
} & HTMLAttributes<HTMLDivElement>;

// TODO: Rework this component, it's not very flexible and example doesn't seem to work properly
// do we really need it or just the hook?
export const Sticky = ({
	children,
	className,
	stuckClassName,
	top,
	bottom,
	...attributes
}: Props) => {
	const ref = useRef<HTMLDivElement>(null);
	const isStuck = useStuck(ref.current, { top, bottom });

	return (
		<div ref={ref} {...attributes} className={cn("sticky", className, isStuck && stuckClassName)}>
			{children}
		</div>
	);
};
